'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  getWebSectionQuery
} from "./chunk-ZYT27J35.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-IIMDQLWJ.mjs";
import {
  gqlClient
} from "./chunk-4T365VQK.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/section/listing.ts
import {
  useInfiniteQuery,
  useQuery
} from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
import { gql } from "graphql-request";
var getSections = (_a) => __async(null, null, function* () {
  var _b = _a, {
    lang = "en",
    contentLimit = 10,
    contentSkip = 0
  } = _b, props = __objRest(_b, [
    "lang",
    "contentLimit",
    "contentSkip"
  ]);
  try {
    const res = yield gqlClient.request(
      minifyGqlQuery(gql`
        query getWebSection(
          $lang: String
          $limit: Int
          $skip: Int
          $where: WebSectionFilter
        ) {
          webSectionCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {
              ${getWebSectionQuery({ contentLimit, contentSkip })}
            }
          }
        }
      `),
      __spreadProps(__spreadValues({}, props), {
        lang: getContentfulSafeLocale(lang)
      })
    );
    return res.webSectionCollection;
  } catch (error) {
    throw new Exception({ error, name: "getSectionByIdException" });
  }
});
var useSections = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["section", props],
    queryFn: () => getSections(props)
  }, options));
};
var useSectionsPaginated = (_a) => {
  var _b = _a, {
    options
  } = _b, props = __objRest(_b, [
    "options"
  ]);
  return useInfiniteQuery(__spreadProps(__spreadValues({
    queryKey: ["sectionsPaginated", props.where],
    queryFn: ({ pageParam }) => getSections(__spreadProps(__spreadValues({}, props), {
      contentSkip: pageParam,
      contentLimit: props.contentLimit || 10
    })),
    getNextPageParam: (lastPage, allPages) => {
      var _a2, _b2;
      const lastPageItems = ((_b2 = (_a2 = lastPage.items[0]) == null ? void 0 : _a2.contentCollection) == null ? void 0 : _b2.items) || [];
      const limit = props.contentLimit || 10;
      return lastPageItems.length === limit ? allPages.length * limit : void 0;
    },
    initialPageParam: options.initialPageParam || 0
  }, options), {
    select(data) {
      return data.pages.flatMap(
        (page) => page.items.flatMap((sec) => {
          var _a2;
          return (_a2 = sec.contentCollection) == null ? void 0 : _a2.items;
        })
      );
    }
  }));
};

export {
  useSections,
  useSectionsPaginated
};
//# sourceMappingURL=chunk-VSTAKFRX.mjs.map